module.exports = __webpack_public_path__ + "static/media/NXR_proposal_V3.77948c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NXR_proposal_V3.png
// module id = 248
// module chunks = 0